import * as React from 'react';
import { SmartRow } from '../../types';

interface Props {
  row: SmartRow;
}

const numberPattern = /\d+/g;

export const Shift: React.FC<Props> = (props) => {
  const { row } = props;

  if (row.type === 'placeholder') {
    return null;
  }

  const { shift } = row;

  const number = shift.match(numberPattern);

  return <span>Shift {number}</span>;
};
Shift.displayName = 'SmartPerDiem.Table.Cell.Shift';
